import { render, staticRenderFns } from "./OrdersReportActions.vue?vue&type=template&id=15504a60"
import script from "./OrdersReportActions.vue?vue&type=script&lang=ts"
export * from "./OrdersReportActions.vue?vue&type=script&lang=ts"
import style0 from "./OrdersReportActions.vue?vue&type=style&index=0&id=15504a60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports